import * as actionTypes from '../../constants/redux.actionTypes'
const initState = {
    search: "",
    pageNo: 0,
    isLoading: false,
    isError: false,
    jobRes: {},
    footerData: [],
}

const jobListReducer = (state = initState, action) => {
    switch (action.type) {
        case actionTypes.TOGGLE_LOAD:
            return {
                ...state,
                isLoading: true
            }

        case actionTypes.GET_JOBS:
            return {
                ...state,
                jobRes: action.jobRes,
                isLoading:false
            }


        case actionTypes.JOB_FETCH_ERROR:
            return {
                ...state,
                isLoading: false,
                isError: true,
                    
            }

        case actionTypes?.UPDATE_SEARCH_TERM: {
            const newState = {
                ...state,
                search: action.payload,
                pageNo: 0
            }
            return newState
        }

        case actionTypes?.INCREMENT_PAGE: {
            const newState = {
                ...state,
                pageNo: action.payload
            }
            return newState
        }

        default:
           return state;
    }
}

export default jobListReducer